import { inject, Injectable } from '@angular/core';

import { AppService } from '@alfresco/aca-shared';
import { PeopleProcessService } from '@alfresco/adf-process-services';
import { UserRepresentation } from '@alfresco/js-api';

import { SetBpmUserAction } from '../store';
import { WkAppConfigService } from './wk-app-config.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkAppService extends AppService {
  protected readonly peopleProcessService = inject(PeopleProcessService);
  protected readonly wkConfig = inject(WkAppConfigService);

  public init(): void {
    super.init();
    this.ready$.subscribe((isReady) => {
      if (isReady) {
        this.loadApsUserProfile();
      }
    });
  }

  protected async loadApsUserProfile(): Promise<void> {
    if (this.wkConfig.apsEnabled()) {
      const userInfo: UserRepresentation = await firstValueFrom(
        this.peopleProcessService.getCurrentUserInfo()
      );
      this['store'].dispatch(new SetBpmUserAction({ bpmUser: userInfo }));
    }
  }
}
